import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl  from '@material-ui/core/FormControl';
import FormHelperText  from '@material-ui/core/FormHelperText';
import FormControlLabel  from '@material-ui/core/FormControlLabel';
import FormGroup  from '@material-ui/core/FormGroup';
import  Select  from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import { autorun } from 'mobx';
import {pending, done, error} from '../stores/State'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress';
import InventoryLocationsMap from './InventoryLocationsMap'

@inject('store')
@observer
/**
 * This class will display Create/Edit view for Customer object
 */
class EditLogisticPlan extends Component {
  static propTypes = {
    isNew: PropTypes.bool
  }

  componentWillMount(){
    const store = this.props.store.logisticPlanStore;

    this.fetchInventoryLocations();

    //IF this is a new Customer
    if(this.props.isNew){
      //Create new instance
      store.createLogisticPlan();
      
      //Add autorun handler to watch when saveState is done
      this.autorunHandler = autorun(()=>{
        if(_.get(store.newLogisticPlan, 'saveState') === done) this.props.history.push(`/accounts/${this.props.match.params.accountId}`)
      })
    }
    //Editing old Customer
    else{
      //Fetch it
      this.fetchLogisticPlan();

      //Add autorun handler to watch when saveState is done
      this.autorunHandler = autorun(()=>{
        if(_.get(store.logisticPlan, 'saveState')  === done) this.props.history.push(`/accounts/${this.props.match.params.accountId}`)
      })
    }
 }

  componentWillUnmount(){
    //Release autorun handler
    this.autorunHandler();
  }

  /**
   * Fetch existing customer using match.params.id
   */
  fetchLogisticPlan(){
    const store = this.props.store.logisticPlanStore;
    store.fetchLogisticPlan(this.props.match.params.id);
  }

  fetchInventoryLocations(){
    const store  = this.props.store.inventoryLocationStore;
    store.fetchAccountInventoryLocations(this.props.match.params.accountId);
  }

  /**
   * Get the customer from store
   */
  get logisticPlan(){
    return this.props.isNew ? this.props.store.logisticPlanStore.newLogisticPlan : this.props.store.logisticPlanStore.logisticPlan;
  }

  addPickup() {
    this.logisticPlan.addPickup({
    });
  }

  handleInventoryLocationChanged(pickup) {
    return (event) => {
      const inventoryLocation = _.find(this.props.store.inventoryLocationStore.inventoryLocations, {id: event.target.value})
      pickup.setInventoryLocation(inventoryLocation);
    };
  }

  handleDestinationLocationChanged(event) {
    const inventoryLocation = _.find(this.props.store.inventoryLocationStore.inventoryLocations, {id: event.target.value})
    this.logisticPlan.setDestinationLocation(inventoryLocation);
  }

  handlePickupDateChange(pickup) {
    return (date) => {
      pickup.setPickupAt(date || null);
    };
  }

  handleWasteTypeChanged(event) {
    const waste_type = event.target.value;
    this.logisticPlan.setWasteType(waste_type);
  }

  isInventoryLocationSelected(inventoryLocation) {
    return _.find(this.logisticPlan.pickups, pickup => _.get(pickup, 'inventory_location.id') == inventoryLocation.id) ||
      (this.logisticPlan.destination && this.logisticPlan.destination.id == inventoryLocation.id);
  }

  renderPickups() {
    const { classes, isNew } = this.props;
    const inventoryLocations = this.props.store.inventoryLocationStore.inventoryLocations;

    return this.logisticPlan.pickups.map(pickup => {
      return (
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Grid item xs={12}>
                <FormControl className={classes.formControl}>
                  <InputLabel>Inventory location</InputLabel>
                  <Select
                    value={pickup.inventory_location ? pickup.inventory_location.id : ""}
                    onChange={this.handleInventoryLocationChanged(pickup)}
                    disabled={pickup.done || this.logisticPlan.archived_at}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>

                    {inventoryLocations && inventoryLocations
                    .map(inventoryLocation =>
                      <MenuItem disabled={this.isInventoryLocationSelected(inventoryLocation)} key={inventoryLocation.id} value={inventoryLocation.id}>
                          {inventoryLocation.customer.name} - {inventoryLocation.name}
                        {!pickup.done && <small className={classes.inventoryCount}>{inventoryLocation.inventory_count}/{inventoryLocation.capacity}</small>}
                        {inventoryLocation.country && <small className={classes.country}>({inventoryLocation.country.name})</small>}
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <InputLabel>Pickup time</InputLabel>
                <DatePicker
                  selected={pickup.pickup_at && moment(pickup.pickup_at)}
                  onChange={this.handlePickupDateChange(pickup)}
                  dateFormat="lll"
                  showTimeSelect
                  disabled={pickup.done || this.logisticPlan.archived_at}
                />
              </Grid>
              <Grid item xs={12}>
                {(!pickup.done && !this.logisticPlan.archived_at) && <Button className={classes.button} variant="contained" type="submit" disabled={pickup.done} onClick={()=>pickup.remove()}>Delete pickup</Button>}
              </Grid>
              {pickup.done && pickup.transactions.length > 0 && <Grid item xs={12}>
                <div>Number of pallets collected: {pickup.transactions.length}</div>
                <div>Total weight of pallets collected: {pickup.totalWeight} kg</div>
              </Grid>}
            </Paper>
          </Grid>
      );
    });
  }

  currentInventoryWeightForPickup(pickup) {
    const inventoryLocations = this.props.store.inventoryLocationStore.inventoryLocations;

    const location = _.find(inventoryLocations, {id: pickup.inventory_location.id});
    if (!location) return 0;
    return location.inventory_weight;
  }

  currentInventoryCountForPickup(pickup) {
    const inventoryLocations = this.props.store.inventoryLocationStore.inventoryLocations;

    const location = _.find(inventoryLocations, {id: pickup.inventory_location.id});
    if (!location) return 0;
    return location.inventory_weight;
  }

  get totalWeight() {
    return this.logisticPlan.pickups
      .filter(pickup => pickup.inventory_location)
      .reduce((value, pickup) => {
        if (pickup.done) {
          return value + pickup.totalWeight;
        } else {
          return value + this.currentInventoryWeightForPickup(pickup);
        }
      }, 0);
  }

  get totalCount() {
    const inventoryLocations = this.props.store.inventoryLocationStore.inventoryLocations;

    return this.logisticPlan.pickups
      .filter(pickup => pickup.inventory_location)
      .reduce((value, pickup) => {
        if (pickup.done) {
          return value + pickup.transactions.length;
        } else {
          return value + this.currentInventoryCountForPickup(pickup);
        }
      }, 0);
  }
  
  render() {    
    const { classes, isNew } = this.props;
    //Get current customer we are crating/editing
    const logisticPlan  = this.logisticPlan;
    const inventoryLocations = this.props.store.inventoryLocationStore.inventoryLocations;

    if(!logisticPlan) return null;
    
    return (
      <Grid container spacing={24}>
        <style>
          {`.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
            padding-left: 0;
            padding-right: 0;
          }`}
        </style>
        <Grid item xs={12}>
          <Typography variant='display3'>{isNew ? 'Create new logistic plan' : 'Edit logistic plan'}</Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Typography variant='title'>Basic information</Typography>

              <FormControl className={classes.formControl}>
                <InputLabel>Destination location</InputLabel>
                <Select
                  value={logisticPlan.destination ? logisticPlan.destination.id : ""}
                  onChange={this.handleDestinationLocationChanged.bind(this)}
                  disabled={!isNew}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>

                  {inventoryLocations && inventoryLocations.map(inventoryLocation =>
                    <MenuItem key={inventoryLocation.id} value={inventoryLocation.id}>
                      {inventoryLocation.name}
                      {inventoryLocation.country && <small className={classes.country}>({inventoryLocation.country.name})</small>}
                    </MenuItem>
                  )}
                  </Select>
              </FormControl>

              <FormControl fullWidth={true} className={classes.formControl}>
                <InputLabel htmlFor="message">Email message</InputLabel>
                <Input disabled={logisticPlan.archived_at} id="message" multiline={true} value={logisticPlan.message} onChange={(event)=>{
                  logisticPlan.setMessage(event.target.value);
                }} />
              </FormControl>

              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="carrier">Carrier</InputLabel>
                <Input disabled={logisticPlan.archived_at} id="carrier" value={logisticPlan.carrier_name} onChange={(event)=>{
                  logisticPlan.setCarrierName(event.target.value);
                }} />
              </FormControl>

              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="carrier_driver">Driver name</InputLabel>
                <Input disabled={logisticPlan.archived_at} id="carrier_driver" value={logisticPlan.carrier_driver_name} onChange={(event)=>{
                  logisticPlan.setCarrierDriverName(event.target.value);
                }} />
              </FormControl>
              
                <FormControl className={classes.formControl}>
                <InputLabel htmlFor="waste_type">Waste type</InputLabel>
                <Select
                  value={logisticPlan.waste_type}
                  onChange={this.handleWasteTypeChanged.bind(this)}
                  disabled={logisticPlan.archived_at}
                >
                  <MenuItem key={"PAPER"} value="PAPER">
                    Paper, paperboard and paper product waste
                  </MenuItem>
                  <MenuItem key={"PLASTIC"} value="PLASTIC">
                    Plastic packaging
                  </MenuItem>
                </Select>
              </FormControl>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            {this.renderPickups()}
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <InventoryLocationsMap/>
        </Grid>

        <Grid item xs={12}>
          <Grid item xs={4} md={2}>
            <Paper className={classes.paper}>
              <Typography className={classes.title} variant='subheading'>Total weight</Typography>
              <Typography variant='title'>{this.totalWeight} kg</Typography>
              <Typography className={classes.title} variant='subheading'>Total count</Typography>
              <Typography variant='title'>{this.totalCount}</Typography>
            </Paper>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {!logisticPlan.archived_at && <Button className={classes.button} color="primary" variant="contained" type="submit" onClick={()=>logisticPlan.save(this.props.match.params.accountId)}>Save</Button>}
          {!logisticPlan.archived_at &&<Button className={classes.button} variant="contained" type="submit" onClick={this.addPickup.bind(this)}>Add pickup</Button>}
          {!isNew &&
            <Button disabled={logisticPlan.fetchExcelState === pending} className={classes.button} variant="contained" type="submit" onClick={()=>logisticPlan.fetchExcel()}>
              Download Excel
            </Button>}
          { logisticPlan.fetchExcelState === pending && <CircularProgress /> }
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  paper:{
    padding: 20,
    marginBottom: 20
  },
  chip: {
    margin: 4,
  },
  recipientTextField:{
    marginRight: 5,
    width: 300
  },
  recipientsContainer:{
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
  },
  inventoryCount: {
    marginLeft: 20
  },
  country: {
    marginLeft: 20
  },
  button: {
    margin: 5
  }
});

export default withRouter(withStyles(styles)(EditLogisticPlan));



// WEBPACK FOOTER //
// ./src/components/EditLogisticPlan.js